import React from "react";
import { Box, Button, CircularProgress, Typography } from "@material-ui/core";
import { lyricsProgress } from "utils/catalogProgress";

// A shared goal for the whole team, not a score for anyone: how many of the
// catalog's songs have lyrics, with a shortcut to the ones that still need them.
export default function CatalogProgress({ songs, onlyMissing, onToggle }) {
  const { total, withLyrics, missing, percent } = lyricsProgress(songs);
  if (total === 0) return null;

  return (
    <Box display="flex" alignItems="center" mb={2} aria-label="Catalog lyrics progress">
      <Box position="relative" display="inline-flex" mr={2}>
        <CircularProgress variant="determinate" value={percent} color="secondary" size={48} aria-label={`${percent}% of songs have lyrics`} />
        <Box position="absolute" top={0} left={0} bottom={0} right={0} display="flex" alignItems="center" justifyContent="center">
          <Typography variant="caption" component="div" color="textSecondary">{`${percent}%`}</Typography>
        </Box>
      </Box>
      <Box>
        <Typography variant="body2">
          {missing === 0
            ? "Every song has lyrics - thank you!"
            : `${missing} ${missing === 1 ? "song still needs" : "songs still need"} lyrics`}
        </Typography>
        <Typography variant="caption" color="textSecondary" component="div">
          {`${withLyrics} of ${total} songs have lyrics`}
        </Typography>
        {missing > 0 && (
          <Button size="small" onClick={onToggle} style={{ marginLeft: -8 }}>
            {onlyMissing ? "Show all songs" : "Show songs without lyrics"}
          </Button>
        )}
      </Box>
    </Box>
  );
}
